import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable()
export class EventIdInterceptor implements HttpInterceptor {

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Only intercept requests to our API
    if (!request.url.startsWith(environment.apiUrl)) {
      return next.handle(request);
    }

    // Check if the request URL contains any of our target endpoints
    if (request.url.includes('/schedule') || 
        request.url.includes('/schedule-categories') ||
        request.url.includes('/schedule-types') ||
        request.url.includes('/lineup') ||
        request.url.includes('/lineup/bydays') ||
        request.url.includes('/lineup/bystages') ||
        request.url.includes('/lineup/byartist') ||
        request.url.includes('/artists/list') ||
        request.url.includes('/artists/public/')
    ) {
      const currentEvent = JSON.parse(localStorage.getItem('current_event') || '{}');
      
      // For GET requests, add eventId to query params
      if (request.method === 'GET') {
        const params = request.params.set('eventId', currentEvent.id);
        request = request.clone({ params });
      }
      
      // For POST requests, add eventId to body
      if (request.method === 'POST') {
        const body = request.body as any;
        request = request.clone({
          body: { ...body, eventId: currentEvent.id }
        });
      }
    }

    return next.handle(request)
  }
} 